import { Component, computed, inject, input, output, signal } from '@angular/core';
import { GameService } from '@core/game/game.service';
import { Wk8BookService } from '@core/wk8/wk8-book.service';
import { LpActionsService } from '@features/lp/lp-actions/lp-actions.service';
import { LpMissionService } from '@features/lp/lp-mission/lp-mission.service';
import { Wk8GlobalsService } from '@features/wk8/core/wk8-globals.service';
import { Wk8BookSentenceComponent } from '@features/wk8/wk8-book/wk8-book-sentence/wk8-book-sentence.component';
import { LpEvent, LpWk8Book, LpWk8BookSentence, LpWk8BookSentencePartFilter, LpWoordData } from '@typings/lp/generated';

@Component({
  selector: 'wk8-book-contents',
  imports: [Wk8BookSentenceComponent],
  templateUrl: './wk8-book-contents.component.html',
  styleUrl: './wk8-book-contents.component.css',
})
export class Wk8BookContentsComponent {
  readonly #gameService = inject(GameService);
  readonly #lpActionsService = inject(LpActionsService);
  readonly #wk8BookService = inject(Wk8BookService);
  readonly #lpMissionService = inject(LpMissionService);
  readonly #wk8GlobalsService = inject(Wk8GlobalsService);

  book = input.required<LpWk8Book>();
  target = input<LpWk8BookSentencePartFilter | undefined>(undefined);
  mode = input.required<'LEVEL_SELECT' | 'WORD_FILL'>();
  highlightedSentence = input<LpWk8BookSentence | undefined>(undefined);
  onStartLevel = input<LpEvent>();

  highligtedPart = signal<LpWk8BookSentencePartFilter | undefined>(undefined);

  wordFilled = output<[spot: LpWk8BookSentencePartFilter, word: LpWoordData | undefined]>();

  sentences = computed(() => this.book().sentences);

  isSentenceComplete(sentence: LpWk8BookSentence): boolean {
    return this.#wk8BookService.isSentenceComplete(sentence);
  }

  async startLevel(sentence: LpWk8BookSentence, part: LpWk8BookSentencePartFilter) {
    await this.#lpActionsService.perform(this.onStartLevel());

    const levelSelectMission = this.#gameService.mission()!;
    const missionTemplate = part.template ?? sentence.template ?? this.book().template;
    if (!missionTemplate) {
      throw new Error('No mission template found for the level select mission');
    }

    this.#wk8GlobalsService.currentLevel = {
      sentence,
      part,
    };

    this.#lpMissionService.start(missionTemplate);
    await this.#lpMissionService.finish();
    await this.#lpMissionService.start(levelSelectMission); // NOTE: queue the level select mission
  }
}
